import React from 'react';

/* Components */
import FlowRendererComponent from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererComponent';

/* Conversion Fields/Components */
import ConversionFieldChoice from './fields/ConversionFieldChoice';
import ConversionFieldChoiceSalesforce from '../../conversion-flow/components/fields/ConversionFieldChoiceSalesforce';
import ConversionFieldUsps from './components/ConversionComponentUsps';
import ConversionFieldInfo from './components/ConversionComponentInfo';
import ConversionFieldLicensePlate from './fields/ConversionFieldLicensePlate';
import ConversionFieldHeader from './fields/ConversionFieldHeader';
import ConversionFieldInput from './fields/ConversionFieldInput';

export default function ConversionFlowComponentRenderer({ flow, group }) {
    return (
        <FlowRendererComponent
            components={flow?.form?.components}
            path={`form.components`}
            id={`form-${flow?.flowId}.components`}
            renderComponent={(component, props) => {
                if (component.group !== group) return (<></>);

                if (component.name === 'usps') {
                    return (<ConversionFieldUsps {...component} />);
                }

                if (component.name === 'info') {
                    return (<ConversionFieldInfo {...component} />);
                }
            }}
            renderField={(field, props) => {
                if (field.type === 'choice-radio') {
                    return (
                        <ConversionFieldChoice
                            {...props}
                            formGroupClassName="form-group--flow-choice-grid"
                            customControlClassName="custom-control--expanded w-100"
                            inputType="radio"
                            componentName={props.component.name}
                        />
                    );
                }

                if (field.type === 'license-plate') {
                    return (
                        <ConversionFieldLicensePlate {...props} inputType="text" />
                    );
                }

                if (field.type === 'header') {
                    return (
                        <ConversionFieldHeader {...props} />
                    );
                }

                if (field.type === 'text' && field.name === 'Rijbewijsnummer' || field.name === 'Geboortedatum') {
                    return (
                        <ConversionFieldInput {...props} inputType={field.type} />
                    )
                }

                if (field.type === 'salesforce-consent') {
                    return (
                        <ConversionFieldChoiceSalesforce
                            {...props}
                            formGroupClassName="form-group--flow-choice-grid"
                            customControlClassName="custom-control w-100"
                            inputType="checkbox"
                        />
                    );
                }
            }}
        />
    )
}
